// extracted by mini-css-extract-plugin
export default {"actions":"SubmissionLogsTable_actions_hysFo","deleted":"SubmissionLogsTable_deleted_K9tYe"};